import React from 'react';
import { useParams } from 'react-router-dom';
import RegistrationFormPanel from '../../components/RegistrationFormPanel';

// Public family-facing registration — …/register/{orgId}/{publicId}. The panel
// draws the club's own header (logo, name, colours).
export default function PublicRegisterPage() {
  const { orgId, publicId } = useParams();
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 py-4 sm:py-8 px-3 sm:px-4" data-testid="public-register-page">
      <RegistrationFormPanel orgId={orgId} publicId={publicId} />
    </div>
  );
}
